export const COMMON_FEATURE_KEY = 'common';
export const MAX_PAX_AMOUNT = 9;
export const MIN_LEAD_PAX_AMOUNT = 1;
export const BOUNDS_FEATURE_KEY = 'bounds';
